import React from 'react';
import PropTypes from 'prop-types';

import { MInputField, MLargeInputField } from './../../molecules';

export default function OContactFormIndustrial({
	subject,
	message,
	onSubjectChange,
	onMessageChange,
}) {
	return (
		<article className="o-contact-list">
			<MInputField
				id="iSubject"
				label="FORM.SUBJECT"
				value={subject}
				placeholder="Geïntresseerd in het kopen van de AL65/AC100"
				required
				onChange={onSubjectChange}
			/>
			<MLargeInputField
				id="iContent"
				label="FORM.MESSAGE"
				value={message}
				required
				onChange={onMessageChange}
			/>
		</article>
	);
}

OContactFormIndustrial.propTypes = {
	subject: PropTypes.string,
	message: PropTypes.string,
	onSubjectChange: PropTypes.func,
	onMessageChange: PropTypes.func,
};

OContactFormIndustrial.defaultProps = {
	subject: undefined,
	message: undefined,
	onSubjectChange: undefined,
	onMessageChange: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/contact/_organisme.contact-form-industrial.js